import image1 from "../../../../assets/DhellServicesImages/11.jpg";
import image2 from "../../../../assets/DhellServicesImages/2.jpg";
import image7 from "../../../../assets/DhellServicesImages/7.jpg";
import image12 from "../../../../assets/DhellServicesImages/10.jpg";

export const staticServicesData = [
  { title: "برامج", image: image12 },
  { title: "خطط تعليم فردية", image: image7 },
  { title: "تنمية المهارات الحركية", image: image2 },
  { title: "الرعاية الطبية", image: image1 },
];
